const About = () => {
    return (
        <section className='page-section' id='chiSiamo'>
            <div className='container' data-aos='fade-up'>
                <div className='text-center'>
                    <h2 className='section-heading text-uppercase'>Chi Siamo</h2>
                    <h3 className='section-subheading text-muted'>
                        "Non siamo l’azienda più grande, ma mettiamo passione ed il massimo impegno in tutti i lavori che realizziamo avendo
                        sempre come fine il massimo risultato possibile per il cliente: di queste caratteristiche facciamo la nostra
                        bandiera"
                    </h3>
                </div>
                <ul className='timeline'>
                    <li>
                        <div className='timeline-image'>
                            <img className='rounded-circle img-fluid' src='/img/about/1.webp' alt='La nostra prima targa' />
                        </div>
                        <div className='timeline-panel'>
                            <div className='timeline-heading'>
                                <h4 className='subheading'>La Nostra Storia</h4>
                            </div>
                            <div className='timeline-body'>
                                <p className='text-muted'>
                                    Azienda storica alla seconda generazione, la Marrone S.r.l. opera sul territorio di Roma con autocarri,
                                    gru, autogru, scale traslochi, carrelli elevatori, sollevatori telescopici, carrelli saliscale, carrelli
                                    per casseforti, carrelli per macchinari di tutte le portate e binde idrauliche di sollevamento.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className='timeline-inverted'>
                        <div className='timeline-image'>
                            <img className='rounded-circle img-fluid' src='/img/about/2.webp' alt='Personale' />
                        </div>
                        <div className='timeline-panel'>
                            <div className='timeline-heading'>
                                <h4 className='subheading'>Il Personale</h4>
                            </div>
                            <div className='timeline-body'>
                                <p className='text-muted'>
                                    Il personale è cresciuto in azienda seguendo indicazioni e professionalità dei formatori più esperti
                                    facendo tesoro di ogni singolo servizio effettuato come tutte le attività che hanno reso grande il
                                    nostro paese in questo settore.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className='timeline-image'>
                            <img className='rounded-circle img-fluid' src='/img/about/3.webp' alt='Ideologia' />
                        </div>
                        <div className='timeline-panel'>
                            <div className='timeline-heading'>
                                <h4 className='subheading'>La Nostra Ideologia</h4>
                            </div>
                            <div className='timeline-body'>
                                <p className='text-muted'>
                                    Formazione e sicurezza sul lavoro sono tutt’oggi alla base della nostra ideologia di lavoro sino ad
                                    arrivare a rendere formatori alcuni componenti del nostro staff.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className='timeline-inverted'>
                        <div className='timeline-image'>
                            <img className='rounded-circle img-fluid' src='/img/about/4.webp' alt='Formazione' />
                        </div>
                        <div className='timeline-panel'>
                            <div className='timeline-heading'>
                                <h4 className='subheading'>Per Concludere</h4>
                            </div>
                            <div className='timeline-body'>
                                <p className='text-muted'>
                                    Siamo, quindi, oggi in grado di formare tutte le categorie di lavoratori per quanto riguarda la
                                    Sicurezza sui luoghi di lavoro.
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
    );
};
export default About;
